// extracted by mini-css-extract-plugin
module.exports = {"CountTableBefore":"CountTableBefore_CountTableBefore__2E5qt"};